import axios from "axios";
import TokenService from "@/services/auth/token.service";
import config from '@/config.json'

const API_URL = config.API_AUTH_URL

class AuthService {

    login({ nickname, password }){
        return axios.post(API_URL + '/login',{
            nickname,
            password
        }).then(response => {
            if (response.data.access_token){
                TokenService.setUser(response.data.access_token)
            }
            return response.data
        })
    }
    loginWithToken(token){
        return axios.get(API_URL + '/sid/'+token).then(response => {
            if (response.data.access_token){
                // alert(1)
                TokenService.setUser(response.data.access_token)
            }
            return response.data
        })
    }

    logout(){
        TokenService.removeUser();
    }

    register(){
        //todo handle axios register
    }
}

export default new AuthService();